var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20C14 21.1 13.1 22 12 22C10.89 22 10 21.1 10 20H14ZM12 2.5C12.8284 2.5 13.5 3.17157 13.5 4V4.68848C16.0879 5.35449 18 7.70419 18 10.5V16H18.5C19.3284 16 20 16.6716 20 17.5C20 18.3284 19.3284 19 18.5 19H5.5C4.67157 19 4 18.3284 4 17.5C4 16.6716 4.67157 16 5.5 16H6V10.5C6 7.70419 7.91209 5.35449 10.5 4.68848V4C10.5 3.17157 11.1716 2.5 12 2.5ZM12 6.5C9.79086 6.5 8 8.29086 8 10.5V17H16V10.5C16 8.29086 14.2091 6.5 12 6.5Z",
    fill: "#002CFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/iconBell.1572dff9f006be8ed910c42f3f9b120d.svg";
export { ForwardRef as ReactComponent };